import { render, staticRenderFns } from "./EquipamentoGerenciarAcoes.vue?vue&type=template&id=12978fc9&"
import script from "./EquipamentoGerenciarAcoes.vue?vue&type=script&lang=js&"
export * from "./EquipamentoGerenciarAcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports